import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { StagePill } from "shared/app/ApplicationStage/StagePill";
import type { ApplicationStageChangedActivity } from "../types";

const StageLabel = ({
  stage
}: {
  stage?: ApplicationStageChangedActivity["details"]["to_stage"];
}) =>
  stage ? (
    <StagePill stage={stage} />
  ) : (
    <span className="text-sm text-content-400">No stage</span>
  );

const subtitle = ({
  activity_type,
  author,
  details
}: ApplicationStageChangedActivity) => {
  if (activity_type === "stage_changed_manual")
    return author?.name ? `Changed by ${author.name}` : null;
  if (details.trigger === "stage_deleted")
    return author?.name
      ? `The stage was deleted by ${author.name}`
      : "The stage was deleted";
  if (details.trigger === "merged")
    return author?.name
      ? `Cleared when ${author.name} merged the application into another group`
      : "Cleared when the application was merged into another group";
  return "Cleared when the application status changed";
};

export const ApplicationStageChanged = ({
  activityItem
}: {
  activityItem: ApplicationStageChangedActivity;
}) => {
  const description = subtitle(activityItem);

  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000">
        {activityItem.activity_type === "stage_changed_manual"
          ? "Stage changed manually"
          : "Stage changed automatically"}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <StageLabel stage={activityItem.details.from_stage} />
        <HugeiconsIcon
          icon={ArrowRight02Icon}
          size={16}
          className="text-content-400"
        />
        <StageLabel stage={activityItem.details.to_stage} />
      </div>
      {description ? (
        <p className="text-sm font-normal text-content-400">{description}</p>
      ) : null}
    </div>
  );
};
